import {Moment} from 'moment-timezone';
import {ValueAndLabelModel} from '../../../../../modules/common/model/valueAndLabel.model';
import {SummaryModel} from '../../../../common/entity/summary.model';
import {PermissionsModel} from '../../../../common/entity/permissions.model';
import {LovValueSummary} from '../../../../common/lov/lov-value/api/model/lovValueSummary.model';
import {BankCheckSummaryModel} from '../../../bank-check/api/model/bankCheckSummary.model';

export class AccountingMovementSummaryModel implements SummaryModel{
    id: number;
    date: Moment;
    amount: number;
    type: ValueAndLabelModel;
    paymentType: ValueAndLabelModel;
    permissions: PermissionsModel;
    counterparty: LovValueSummary;
    bankCheck: BankCheckSummaryModel;
}
